import usePrice from '@Hooks/usePrice';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Edit from 'public/edit.svg';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import {
  Card,
  Content,
  Cta,
  Div,
  Footer,
  Header,
  Item,
  Price,
  Title,
  Total,
  TotalPrice,
} from './OrderSummaryCard.styled';

type Props = {};
export default function OrderSummaryCard({}: Props) {
  const { t } = useTranslation('Checkout');
  const { data } = useSelector((state: RootState) => state.checkout);
  const { thePrice: totalItemsPrice } = usePrice(data?.total_price?.total_items_price || 0);
  const { thePrice: totalDiscount } = usePrice(data?.total_price?.total_discount || 0);
  const { thePrice: shippingPrice } = usePrice(data?.total_price?.shipping_price || 0);
  const { thePrice: shippingInSameDay } = usePrice(data?.total_price?.shipping_in_same_day || 0);
  const { thePrice: installationCost } = usePrice(data?.total_price?.total_installation_cost || 0);
  const { thePrice: totalPrice } = usePrice(data?.total_price?.total_price || 0);

  return (
    <Card>
      <Header>
        <Title>{t('summary')}</Title>
        <Cta href="/cart">
          <Image src={Edit} width={24} height={24} alt="edit" />
        </Cta>
      </Header>
      <Content>
        <Div>
          <Item>{t('total_product')}</Item>
          <Price>{totalItemsPrice}</Price>
        </Div>
        {Boolean(data?.total_price?.total_discount) && (
          <Div>
            <Item>{t('discount')}</Item>
            <Price>{totalDiscount}</Price>
          </Div>
        )}
        {Boolean(data?.total_price?.shipping_price) && (
          <Div>
            <Item>{t('delivery')}</Item>
            <Price>{shippingPrice}</Price>
          </Div>
        )}
        {Boolean(data?.total_price?.shipping_in_same_day) && (
          <Div>
            <Item>{t('delivery-same-day')}</Item>
            <Price>{shippingInSameDay}</Price>
          </Div>
        )}
        {Boolean(data?.total_price?.total_installation_cost) && (
          <Div>
            <Item>{t('installation')}</Item>
            <Price>{installationCost}</Price>
          </Div>
        )}
        <Footer>
          <Total>{t('total')}</Total>
          <TotalPrice>{totalPrice}</TotalPrice>
        </Footer>
      </Content>
    </Card>
  );
}
